import React, { useEffect, useState } from "react";
import { FileText, X } from "lucide-react";

function CreateEventOnAddDevicePopup({ eventkeywordvalue, closePopup, confirm }) {
    const [eventkeyword, setEventKeyword] = useState(eventkeywordvalue || "");

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "";
        };
    }, []);

    const onContinueClick = () => {
        closePopup();
        confirm(eventkeyword);
    };

    return (
        <div className="oct-shared-popup" role="dialog" aria-modal="true" aria-labelledby="oct-add-event-keyword-title">
            <div className="oct-shared-popup__backdrop" onClick={closePopup} />

            <div className="oct-shared-popup__dialog oct-shared-popup__dialog--compact" onClick={(event) => event.stopPropagation()}>
                <div className="oct-shared-popup__header">
                    <div className="oct-shared-popup__title-wrap">
                        <div className="oct-shared-popup__title-icon">
                            <FileText size={18} />
                        </div>
                        <h4 id="oct-add-event-keyword-title" className="oct-shared-popup__title">Add Event</h4>
                    </div>

                    <button type="button" className="oct-shared-popup__close" onClick={closePopup} aria-label="Close popup">
                        <X size={18} />
                    </button>
                </div>

                <div className="oct-shared-popup__body oct-shared-popup__body--form">
                    <div className="oct-shared-popup__field">
                        <label className="oct-shared-popup__label" htmlFor="event-keyword">
                            Event Keyword <span className="oct-shared-popup__required-mark">*</span>
                        </label>
                        <input
                            id="event-keyword"
                            className="oct-shared-popup__input"
                            value={eventkeyword}
                            autoComplete="off"
                            onChange={(event) => setEventKeyword(event.target.value)}
                            placeholder="Enter event keyword"
                        />
                    </div>
                </div>

                <div className="oct-shared-popup__footer oct-shared-popup__footer--end">
                    <button type="button" className="btn oct-shared-popup__btn oct-shared-popup__btn--secondary" onClick={closePopup}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn oct-shared-popup__btn oct-shared-popup__btn--primary"
                        disabled={!eventkeyword}
                        onClick={onContinueClick}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CreateEventOnAddDevicePopup;
